// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectMediaProductEdit {
    cursor: pointer;
    width: 100%;
    border: 1px dashed #ced4da;
    border-radius: 15px;
    background-color: rgb(248 248 248);
    padding-left: 40%;
    padding-top: 30px;
}

.selectinputfileProductEdit {
    opacity: 0;
    width: 100%;
    cursor: pointer;
}

.short_describtion {
    margin-bottom: 20px;
}

.short_describtion .textEditorContainor .ql-container {
    height: 134px !important;
}

.short_describtion .textEditorContainor {
    height: 200px !important;
}

.describtion {
    margin-bottom: 20px;
}

.describtion .textEditorContainor .ql-container {
    height: 244px !important;
}

/* .describtion .textEditorContainor { */
    /* height: 310px !important;
} */

.describtionEditor .ql-container {
    height: 244px !important;
    margin-bottom: 20px;
}

.describtionEditor .textEditorContainor{
    height: auto !important;
}


.page_2_portrait .textEditorContainor .ql-container {
    height: 156px !important;
}

.page_2_portrait .ql-container{
    height: 200px !important;
}

.page_2 .textEditorContainor {
    height: 260px !important;
}

.page_content .textEditorContainor .ql-container{
    height: 370px !important;
}

.page_content .textEditorContainor {
    height: 450px !important;
}

.searchList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 8px 14px;
    margin: 8px 0;
    font-size: 13px;
    transition: all 0.2s ease;
}

.searchList:hover {
    background: #f1f3f5;
}

.searchList .categoryName {
    font-weight: 500;
    color: #212529;
}

.searchList .primaryCategoryWrapper {
    display: flex;
    align-items: center;
}

.searchList .primaryCategoryLabel {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 0;
    margin-right: 16px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    font-size: 13px;
    line-height: 1;
    color: #6c757d;
}

.searchList .primaryCategoryLabel.isPrimary {
    color: #212529;
    font-weight: 600;
}

.searchList .primaryCategoryCheckbox {
    margin: 0 !important;
    width: 16px !important;
    height: 16px !important;
    cursor: pointer;
    accent-color: var(--admin-color, #4c84ff);
    flex-shrink: 0;
    vertical-align: middle;
}

.searchList .removeProduct {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    color: #8a909d;
    transition: all 0.2s ease;
}

.searchList .removeProduct:hover {
    background: #fee2e2;
    color: #dc3545;
}

.searchList .removeProduct .mdi {
    font-size: 16px;
    line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/Components/Product/EditProduct/EditProduct.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,0BAA0B;IAC1B,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,wCAAwC;IACpC;GACD;;AAEH;IACI,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":[".selectMediaProductEdit {\n    cursor: pointer;\n    width: 100%;\n    border: 1px dashed #ced4da;\n    border-radius: 15px;\n    background-color: rgb(248 248 248);\n    padding-left: 40%;\n    padding-top: 30px;\n}\n\n.selectinputfileProductEdit {\n    opacity: 0;\n    width: 100%;\n    cursor: pointer;\n}\n\n.short_describtion {\n    margin-bottom: 20px;\n}\n\n.short_describtion .textEditorContainor .ql-container {\n    height: 134px !important;\n}\n\n.short_describtion .textEditorContainor {\n    height: 200px !important;\n}\n\n.describtion {\n    margin-bottom: 20px;\n}\n\n.describtion .textEditorContainor .ql-container {\n    height: 244px !important;\n}\n\n/* .describtion .textEditorContainor { */\n    /* height: 310px !important;\n} */\n\n.describtionEditor .ql-container {\n    height: 244px !important;\n    margin-bottom: 20px;\n}\n\n.describtionEditor .textEditorContainor{\n    height: auto !important;\n}\n\n\n.page_2_portrait .textEditorContainor .ql-container {\n    height: 156px !important;\n}\n\n.page_2_portrait .ql-container{\n    height: 200px !important;\n}\n\n.page_2 .textEditorContainor {\n    height: 260px !important;\n}\n\n.page_content .textEditorContainor .ql-container{\n    height: 370px !important;\n}\n\n.page_content .textEditorContainor {\n    height: 450px !important;\n}\n\n.searchList {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #f8f9fa;\n    border: 1px solid #e9ecef;\n    border-radius: 6px;\n    padding: 8px 14px;\n    margin: 8px 0;\n    font-size: 13px;\n    transition: all 0.2s ease;\n}\n\n.searchList:hover {\n    background: #f1f3f5;\n}\n\n.searchList .categoryName {\n    font-weight: 500;\n    color: #212529;\n}\n\n.searchList .primaryCategoryWrapper {\n    display: flex;\n    align-items: center;\n}\n\n.searchList .primaryCategoryLabel {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    margin-bottom: 0;\n    margin-right: 16px;\n    cursor: pointer;\n    user-select: none;\n    font-size: 13px;\n    line-height: 1;\n    color: #6c757d;\n}\n\n.searchList .primaryCategoryLabel.isPrimary {\n    color: #212529;\n    font-weight: 600;\n}\n\n.searchList .primaryCategoryCheckbox {\n    margin: 0 !important;\n    width: 16px !important;\n    height: 16px !important;\n    cursor: pointer;\n    accent-color: var(--admin-color, #4c84ff);\n    flex-shrink: 0;\n    vertical-align: middle;\n}\n\n.searchList .removeProduct {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    color: #8a909d;\n    transition: all 0.2s ease;\n}\n\n.searchList .removeProduct:hover {\n    background: #fee2e2;\n    color: #dc3545;\n}\n\n.searchList .removeProduct .mdi {\n    font-size: 16px;\n    line-height: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
